import {Component, Input, OnInit} from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthenticationService, DecodedJwt } from '@colimo/colimo-ui-library';
import { Observable } from 'rxjs';
import { Language } from 'src/app/models/language.model';
import { Sidenav } from 'src/app/models/sidenav.model';
import { LanguagesService } from 'src/app/services/languages/languages.service';
import { environment } from 'src/environments/environment';
import * as fromRoot from '../../reducers';
import {Router, RouterLink} from '@angular/router';
import {TranslateModule} from "@ngx-translate/core";
import {AsyncPipe, NgClass} from "@angular/common";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'colimo-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  imports: [
    MatIcon,
    TranslateModule,
    AsyncPipe,
    MatMenuItem,
    MatMenu,
    RouterLink,
    MatMenuTrigger,
    NgClass
  ]
})
export class SettingsComponent implements OnInit {
  @Input() public alertsConfigured: boolean;
  public adminToolPath: string;
  public languages: Language[];
  public sidenavCollapsed: boolean;
  public authenticated: Observable<DecodedJwt>;

  constructor(
    private authenticationService: AuthenticationService,
    private languagesService: LanguagesService,
    private store: Store<fromRoot.State>,
    private router: Router
  ) {}

  public ngOnInit(): void {
    this.adminToolPath = environment.adminPath;
    this.authenticated = this.authenticationService.authentication;
    this.store.select(fromRoot.getSidenav).subscribe((sidenav: Sidenav) => {
      this.sidenavCollapsed = sidenav.sidenavCollapsed;
    });
    this.languages = this.languagesService.getAvailableLanguages();
  }

  public updateLanguage(language: Language): void {
    this.languagesService.setCurrentLanguage(language);
  }

  public goToAlertSettings(): void {
    this.router.navigate(['/notification-center'], { state: { selectedTab: 1 } });
  }
}
